<template>
  <TryNewTeamworkButton
    class="mx-2 try-new-teamwork-for-everyone-button"
    v-close-popover
    :title="$t('New Teamwork for everyone')"
    data-identifier="sidebar-new-teamwork-for-everyone"
    @click="openSwitchEveryoneModal"
  />
</template>

<script>
import moment from 'moment';
import { onMounted } from 'vue-demi';
import useStore from '@/platform/composables/useStore';
import { usePreferences } from '@/platform/composables/usePreferences';
import TryNewTeamworkButton from '../switch-flow/TryNewTeamworkButton.vue';

export default {
  components: {
    TryNewTeamworkButton,
  },
  setup() {
    const store = useStore();

    const { shouldShowSwitchEveryoneModal, postponeSwitchEveryoneModalUntil } =
      usePreferences();

    function openSwitchEveryoneModal() {
      store.dispatch('modals/open', {
        name: 'switch-everyone-to-new-teamwork-modal',
      });
    }
    onMounted(() => {
      // nextTick seems not working
      setTimeout(() => {
        const postponeUntil = postponeSwitchEveryoneModalUntil.value;
        const timestampNow = moment.utc().unix();
        if (
          shouldShowSwitchEveryoneModal.value && // admin has not clicked on `X` button
          (!postponeUntil || // admin has just switched to new sidebar
            Number(postponeUntil) < timestampNow) // admin previously clicked on "Remind me tomorrow" option and 24 hrs passed
        ) {
          openSwitchEveryoneModal();
        }
      }, 1000);
    });

    return {
      openSwitchEveryoneModal,
    };
  },
};
</script>

<style scoped>
.try-new-teamwork-for-everyone-button {
  width: 230px;
}
</style>
